import {Entite} from '@Services/gestion-universite/entite/entite.model';
import {Individu} from '@Common/core/services';
import {Box} from 'app/archivage/common/services/box/box.model';
import {Magasin} from 'app/archivage/common/services/magasin/magasin.model';
import {DirCmpEntite} from '../dircmp/dircmp.model';

export interface Deposit {
  id?: number;
  dir_cmp?: number;
  svc_dep?: number;
  svc_autre?: string;
  user?: string;
  contacts?: string[];
  office?: string;
  phone_number?: string;
  contacts_obj?: Individu[];
  linear_size?: number;
  article_number?: number;
  conservation?: DepositConservation;
  revision_year_min?: number;
  revision_year_max?: number;
  incoming_date?: string;
  state?: DepositState;
  motif?: string;
  deposit_identifier?: string;
  location?: number;

  dir_cmp_obj?: DirCmpEntite;
  svc_dep_obj?: Entite;
  user_obj?: Individu;
  boxes_number?: number;
  boxs_obj?: Box[];
  location_obj?: DepositLocation;

  dt_created: string;
  dt_updated: string;
  content_type?: number;
}

export interface DepositAction {
  id?: number;
  motif?: string;
  action_type?: number;
  user?: string;
  deposit: Deposit;
  dt_created: string;
  dt_updated: string;
  content_type?: number;
}

export interface DepositLocation {
  magasin?: number;
  epi?: string; // 16
  tra?: string; // 16
  ray?: string; // 16
  tab?: string; // 16

  magasin_obj?: Magasin;
}

/**
 * Mapping form => modele Deposit
 * field_model, field_form, obligatoire
 */
export const depositControls: [string, string][] = [
  ['office', 'office'],
  ['phone_number', 'phoneNumber'],
  ['dir_cmp', 'dircmpSelected'],
  ['svc_dep', 'svcdepSelected'],
  ['svc_autre', 'svcAutre'],
  ['conservation', 'conservationSelected'],
];

export enum DepositState {
  DONE = 1,
  WAITING = 2,
  DRAFT = 3,
  INCOMPLETE= 4,
  ARCHIVED= 5,
}
export enum DepositConservation {
  UNDEF = 0,
  INTEGRAL = 1,
  PARTIAL = 2,
  ELIMINATE = 3,
  SCAN = 4,
}
